import type { DialogueImageMessage } from 'components/Dialogue/types';
import { ImageMessage } from 'components/Dialogue';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import QuoteMessage from '../QuoteMessage';
import { useChatContext } from '../../contexts/ChatContext';
import { memo } from 'react';
import { getFacebookMessage } from 'services/api/conversation';
import { noop } from 'lodash-es';
import { useUpdateMessage } from 'hooks/business/message';

export const ImageMsg = memo((props: BaseMsgProps) => {
  const { raw, msg, conversation } = props;
  const { dialogRef, clickQuote } = useChatContext();
  const { url } = (msg as DialogueImageMessage).content;
  const { localUpload, imageContent } = msg.raw;
  const { width, height } = imageContent || {};
  const { topBarInfo } = conversation;

  const updateMessage = useUpdateMessage();

  const src =
    conversation.channel === 'KWAI' || conversation.channel === 'TIKTOK'
      ? raw.imageContent?.imgUrl || url
      : url;

  return (
    <MessageExtendComplex
      {...props}
      content={
        <QuoteMessage
          message={raw}
          storeName={topBarInfo?.storeName}
          wrap
          onQuoteClick={clickQuote}
        >
          <ImageMessage
            key={src}
            src={src}
            width={200}
            uploading={msg.raw.localStatus === 'uploading'}
            imgSize={width && height ? { width, height } : undefined}
            localUpload={localUpload}
            lazyScrollContainer={dialogRef?.dom}
            onLoad={
              conversation.channel === 'FACEBOOK' &&
              raw.fbMsgContent?.expireTimestamp &&
              Number(raw.fbMsgContent.expireTimestamp) > 0 &&
              Date.now() > Number(raw.fbMsgContent.expireTimestamp)
                ? () => {
                    getFacebookMessage({ storeId: raw.storeId, msgId: raw.msgId })
                      .then(({ fbMsgContent }) => {
                        updateMessage(raw.msgId, (prev) => {
                          if (!prev) {
                            return undefined;
                          }
                          return {
                            ...prev,
                            fbMsgContent,
                          };
                        });
                      })
                      .catch(noop);
                  }
                : undefined
            }
          />
        </QuoteMessage>
      }
    />
  );
});
